export default __webpack_public_path__ + "static/g8432-8e89545523be36adeab1c95f2eaadcbf.svg";